module.exports = __webpack_public_path__ + "img/sv.f5dc02fc.svg";